import { AnimatePresence, XStack, YStack } from "tamagui";
import { Info } from "@tamagui/lucide-icons";
import { BentoInput } from "../bento/inputParts";
import { Paragraph2 } from "../Typography";
export interface FormErrorProps {
  errorMessage: string | undefined | null;
}
export const FormError = ({
  errorMessage
}: FormErrorProps) => {
  return <XStack position="relative" width="100%" data-sentry-element="XStack" data-sentry-component="FormError" data-sentry-source-file="FormError.tsx">
      <AnimatePresence data-sentry-element="AnimatePresence" data-sentry-source-file="FormError.tsx">
        {/* This block pushes down any content below the error, while the
            second block uses absolute positioning to animate the text */}
        {errorMessage ? <YStack key="form-error-spacer" height="$1.5" enterStyle={{
        height: 0
      }} exitStyle={{
        height: 0
      }} transition="bouncyTight"></YStack> : null}
      </AnimatePresence>
      <AnimatePresence data-sentry-element="AnimatePresence" data-sentry-source-file="FormError.tsx">
        {errorMessage ? <XStack py="$1.5" top={0} key="form-error-entry" px={16} position="absolute" gap="$1.5" width="100%" flexDirection="row" transition="bouncyTight" alignItems="center" scaleY={1} enterStyle={{
        opacity: 0,
        y: -10,
        scaleY: 0.5
      }} exitStyle={{
        opacity: 0,
        y: -10,
        scaleY: 0.5
      }} theme="red">
            <BentoInput.Icon padding={0}>
              <Info color="$color10" strokeWidth={2} height={16} width={16} />
            </BentoInput.Icon>
            <BentoInput.Info color="$color10" flex={1} numberOfLines={1} size="$2" lineHeight={16}>
              {errorMessage}
            </BentoInput.Info>
          </XStack> : null}
      </AnimatePresence>
    </XStack>;
};
export const FormErrorMessage = ({
  errorMessage
}: FormErrorProps) => {
  return <XStack position="relative" width="100%" data-sentry-element="XStack" data-sentry-component="FormErrorMessage" data-sentry-source-file="FormError.tsx">
      <AnimatePresence data-sentry-element="AnimatePresence" data-sentry-source-file="FormError.tsx">
        {/* Spacer element to push down content below */}
        {errorMessage ? <YStack key="error-message-spacer" height="$3" enterStyle={{
        height: 0
      }} exitStyle={{
        height: 0
      }} transition="bouncyTight" /> : null}
      </AnimatePresence>
      <AnimatePresence data-sentry-element="AnimatePresence" data-sentry-source-file="FormError.tsx">
        {/* Absolutely positioned content for smooth animation */}
        {errorMessage ? <XStack key="error-message-content" position="absolute" top={0} width="100%" height="$3" alignItems="center" justifyContent="center" gap="$2" borderRadius="$2" borderWidth="$1" borderColor="$red10" padding="$2" backgroundColor="$red2" scaleY={1} enterStyle={{
        opacity: 0,
        y: -10,
        scaleY: 0.5
      }} exitStyle={{
        opacity: 0,
        y: -10,
        scaleY: 0.5
      }} transition="bouncyTight">
            <Info color="$red10" pt="$1" height={18} width={18} />
            <Paragraph2 color="$red10">{errorMessage}</Paragraph2>
          </XStack> : null}
      </AnimatePresence>
    </XStack>;
};